import * as actionTypes from "../constants/actionTypes";
import backend from "../utils/backend";
import { updateAxiosToken, backendLogOut } from "../utils/auth";
import { removeLocalItem } from "../utils/localdb";
import { getUserData } from "actions/user";

export var toggleAuthDrawer = function toggleAuthDrawer(bool) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.AUTH_DRAWER_OPEN,
      payload: bool
    });
  };
};

export var changeStep = function changeStep(step) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.CHANGE_STEP,
      payload: step
    });
  };
};

export var setBasicInfo = function setBasicInfo(userData) {
  return function (dispatch) {
    return backend.request({
      method: "POST",
      url: "/readers/validate-email/",
      data: {
        email: userData.email
      }
    }).then(function (response) {
      if (response.data.available) {
        dispatch({
          type: actionTypes.SET_BASIC_INFO,
          payload: userData
        });

        dispatch({
          type: actionTypes.EMAIL_AVAILABLE
        });
      } else {
        dispatch({
          type: actionTypes.EMAIL_NOT_AVAILABLE
        });
      }
    }).catch(function (err) {
      dispatch({
        type: actionTypes.EMAIL_VALIDATION_REQUEST_ERROR,
        payload: err
      });
    });
  };
};

export var setOptionalInfo = function setOptionalInfo(userData) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: actionTypes.SET_OPTIONAL_INFO,
        payload: userData
      });

      resolve();
    });
  };
};

export var registerEmail = function registerEmail(userData) {
  return function (dispatch) {
    return backend.request({
      method: "POST",
      url: "/readers/create-user/",
      data: userData
    }).then(function (response) {
      dispatch({
        type: actionTypes.CREATE_USER_SUCCESS,
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.CREATE_USER_ERROR,
        payload: err
      });
    });
  };
};

export var requestPasswordReset = function requestPasswordReset(email) {
  return function (dispatch) {
    return backend.request({
      method: "POST",
      url: "/readers/forgot-password/",
      data: {
        email: email
      }
    }).then(function () {
      dispatch({
        type: actionTypes.PASSWORD_RESET_REQUEST_SUCCESS
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.PASSWORD_RESET_REQUEST_ERROR,
        payload: err
      });
    });
  };
};

export var setPasswordResetInfo = function setPasswordResetInfo(token, email) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.SET_PASSWORD_RESET_INFO,
      payload: {
        token: token,
        email: email
      }
    });
  };
};

export var changePassword = function changePassword(token, email, passwords) {
  return function (dispatch) {
    return backend.request({
      method: "POST",
      url: "/readers/reset-password/",
      data: {
        token: token,
        email: email,
        password1: passwords.password1,
        password2: passwords.password2
      }
    }).then(function () {
      dispatch({
        type: actionTypes.PASSWORD_RESET_SUCCESS
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.PASSWORD_RESET_ERROR,
        payload: err
      });
    });
  };
};

export var setAuthToken = function setAuthToken(authToken) {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: actionTypes.SET_AUTH_TOKEN,
        payload: authToken
      });

      dispatch({
        type: actionTypes.LOGGED_IN_STATUS,
        payload: true
      });

      updateAxiosToken(authToken);

      dispatch(getUserData()).then(function () {
        resolve();
      });
    });
  };
};

export var logOut = function logOut() {
  return function (dispatch) {
    return new Promise(function (resolve) {
      backendLogOut();

      dispatch({
        type: actionTypes.LOG_OUT
      });

      removeLocalItem("authToken");

      resolve();
    });
  };
};

export var confirmEmail = function confirmEmail(token, email) {
  return function (dispatch) {
    return backend.request({
      method: "POST",
      url: "/readers/confirm-email/",
      data: {
        token: token,
        email: email
      }
    }).then(function () {
      dispatch({
        type: actionTypes.EMAIL_CONFIRM_SUCCESS
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.EMAIL_CONFIRM_ERROR,
        payload: err
      });
    });
  };
};


// WEBPACK FOOTER //
// ./src/actions/authDrawer.js